module.exports = __webpack_public_path__ + "img/Rectangle 20.82eaf0f2.png";